import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-textitalic",
  "use": "icon-th-textitalic-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-textitalic\">\n<path d=\"M25 7C25 7.26522 24.8946 7.51957 24.7071 7.70711C24.5196 7.89464 24.2652 8 24 8H19.7213L14.3875 24H18C18.2652 24 18.5196 24.1054 18.7071 24.2929C18.8946 24.4804 19 24.7348 19 25C19 25.2652 18.8946 25.5196 18.7071 25.7071C18.5196 25.8946 18.2652 26 18 26H8C7.73478 26 7.48043 25.8946 7.29289 25.7071C7.10536 25.5196 7 25.2652 7 25C7 24.7348 7.10536 24.4804 7.29289 24.2929C7.48043 24.1054 7.73478 24 8 24H12.2788L17.6125 8H14C13.7348 8 13.4804 7.89464 13.2929 7.70711C13.1054 7.51957 13 7.26522 13 7C13 6.73478 13.1054 6.48043 13.2929 6.29289C13.4804 6.10536 13.7348 6 14 6H24C24.2652 6 24.5196 6.10536 24.7071 6.29289C24.8946 6.48043 25 6.73478 25 7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-textitalic.svg
// module id = EUG8
// module chunks = 84